module.exports = __webpack_public_path__ + "static/media/_DSC6068.08a8a3f2.jpg";